import { logger } from './logger';
import { makeAuthenticatedRequest } from './api';

export interface LeaderboardEntry {
  rank: number;
  userId: number;
  username: string;
  value: number;
}

export interface LeaderboardResponse {
  entries: LeaderboardEntry[];
  yourRank: number | null;
  yourValue: number | null;
}

export interface NamedBoss {
  monsterId: number;
  name: string;
  townName: string | null;
}

const EMPTY_RESPONSE: LeaderboardResponse = { entries: [], yourRank: null, yourValue: null };

const fetchLeaderboard = async (endpoint: string): Promise<LeaderboardResponse> => {
  try {
    const response = await makeAuthenticatedRequest(`/Leaderboards${endpoint}`);
    if (!response.ok) {
      logger.error('Failed to fetch leaderboard:', endpoint, response.statusText);
      return EMPTY_RESPONSE;
    }
    return await response.json();
  } catch (error) {
    logger.error('Error fetching leaderboard:', endpoint, error);
    return EMPTY_RESPONSE;
  }
};

export const getBattlesWonLeaderboard = () => fetchLeaderboard('/battles-won');
export const getTilesUnlockedLeaderboard = () => fetchLeaderboard('/tiles-unlocked');
export const getWeeklyChallengesLeaderboard = () => fetchLeaderboard('/weekly-challenges');
export const getBossClearLeaderboard = (monsterId: number) => fetchLeaderboard(`/boss-clear/${monsterId}`);

export const getNamedBosses = async (): Promise<NamedBoss[]> => {
  try {
    const response = await makeAuthenticatedRequest('/Leaderboards/bosses');
    if (!response.ok) {
      logger.error('Failed to fetch named bosses:', response.statusText);
      return [];
    }
    const data = await response.json();
    return data.bosses ?? [];
  } catch (error) {
    logger.error('Error fetching named bosses:', error);
    return [];
  }
};
